import store from "@/store";
import { uploadCsvFile } from "./storageService";

const options = { 
  year: 'numeric', 
  month: 'long', 
  day: 'numeric', 
  hour: '2-digit', 
  minute: '2-digit', 
  second: '2-digit',
  hour12: true 
};

export function logError(err, info) {
    const errorLog = {
      timestamp: new Date().toISOString(),
      dateTime: new Date().toLocaleString(undefined, options),
      error: err,
      info: info,
      pageURL: window.location.href,
      stack: err.stack,
    };
    //console.log("Logged ui-error");
    store.dispatch("logError", errorLog);
  }

  export function logTestError(err, testName, testId, testInstanceId, errFrom) {
    const testErrorLog = {
      timestamp: new Date().toISOString(),
      dateTime: new Date().toLocaleString(undefined, options),
      errFrom: errFrom,
      testName: testName || "No Test Name",
      testId: testId || "No Test ID",
      testInstanceId: testInstanceId || "No Test Instance ID",
      error: JSON.stringify(err),
      stack: err.stack,
    };
    //console.log("Logged test error");
    store.dispatch("logTestError", testErrorLog);
  }

  export function logNetworkError(error) {
    if(error.config?.url.split("/")[error.config?.url.split("/").length-1] === "here"){
      return;
    }
    const networkErrorLog = {
      timestamp: new Date().toISOString(),
      dateTime: new Date().toLocaleString(undefined, options),
      message: error.message || 'Network error occurred',
      stack: error.stack || 'No stack trace available',
      config: {data: error.config.data, method: error.config.method} || {},  // for axios
      url: error.config?.url || 'No URL available',
    };
    //console.log("Looged network error");
    store.dispatch("logNetworkError", networkErrorLog);
  }

  export function checkLogsSizeInKB(logsArray){
    const jsonString = JSON.stringify(logsArray);
    const byteSize = new Blob([jsonString]).size;
    const kbSize = byteSize / 1024;
    return kbSize;
  }

  export async function saveLogToFile(logsArray, logType) {
    const blob = new Blob([JSON.stringify(logsArray, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${logType}-${new Date().toISOString()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  }

  export function convertTestSolutionJsonToCsv(data, name, isPractice){
    convertToCSV(data,name, false, isPractice );
  }

  export function convertTestSolutionJsonToCsvAndUploadToServer(data, name, isPractice){
    convertToCSV(data,name, true, isPractice);
  }

  async function convertToCSV(jsonArray,name, uploadToServer, isPractice) {
    //this.loading = true;

    // Use a Web Worker to perform the conversion off the main thread
    const rollnumber = store.state.profileInfo.organization.rollNumber || "";
    const data = {rollNumber: rollnumber, jsonArray}

    const worker = new Worker(URL.createObjectURL(new Blob([`
      self.onmessage = function(e) {
      const jsonArray = e.data.jsonArray;
      const rollNumber = e.data.rollNumber

      const headers = [
        'qNo',
        'index',
        'qId',
        'qType',
        'sectionId',
        'sectionName',
        'checkedOption',
        'checkedOptions',
        'integerOption',
        'decimalOption',
        'markedForReview'
      ];


      let csv = headers.join(',') + '\\n';

      csv += jsonArray.map(item => 
        item.responses.map(obj => {
          return [
            obj.qNo,
            obj.index,
            obj.qId,
            obj.qType,
            obj.sectionId,
            obj.sectionName,
            obj.checkedOption ? obj.checkedOption : "",
            obj.checkedOptions ? obj.checkedOptions.join('_') : "",
            obj.integerOption ? obj.integerOption : "",
            obj.decimalOption ? obj.decimalOption : "",
            obj.markedForReview
          ].join(',');
        }).join('\\n')
      ).join('\\n');
      
      self.postMessage(csv);
    };
    `])));

    worker.onmessage = (e) => {
      if(uploadToServer){
        uploadReportsToServerCSV(e.data, name, isPractice);
      }else{
        downloadCSV(e.data, name, isPractice);
      }
      //this.loading = false;
      worker.terminate(); 
    };

    worker.postMessage(JSON.parse(JSON.stringify(data)));
  }

  function uploadReportsToServerCSV(csvContent, testId, isPractice) {
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const rollnumber = store.state.profileInfo.organization.rollNumber ? store.state.profileInfo.organization.rollNumber : localStorage.getItem("name");
    uploadCsvFile(blob,'VMCStudentDocuments/testReports',testId,rollnumber,isPractice);
  }


  function downloadCSV(csvContent, name, isPractice) {
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const rollnumber = store.state.profileInfo.organization.rollNumber ? store.state.profileInfo.organization.rollNumber : localStorage.getItem("name");
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    if(isPractice){
      a.download = `${name}_${rollnumber}_practice_response.csv`;
    }else{
      a.download = `${name}_${rollnumber}_response.csv`;
    }
    a.click();
    URL.revokeObjectURL(url);
  }


